export default "__VITE_ASSET__DlXOV5qk__"